module.exports = __webpack_public_path__ + "img/heart-red.e25873a9.svg";